export const ArrowRightIcon = ({
  className,
}: {
  className?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.251051 10.3559C0.560038 10.6649 1.04624 10.6886 1.38249 10.4272L1.46323 10.3559L5.74895 6.07017C6.05794 5.76118 6.0817 5.27498 5.82025 4.93873L5.74895 4.85798L1.46323 0.57227C1.1285 0.237535 0.585787 0.237535 0.251051 0.57227C-0.0579349 0.881257 -0.0817031 1.36746 0.179747 1.7037L0.251051 1.78445L3.93 5.46408L0.251051 9.1437C-0.0579349 9.45269 -0.0817031 9.93888 0.179747 10.2751L0.251051 10.3559Z"
      fill="currentColor"
    />
  </svg>
);
